import { Icon } from '../types/icons';

export const swimwearIcons: Icon[] = [
	{ key: 'bikini-1', url: 'https://cdn.easysize.me/icons/bikini-swimwear.svg' },
	{ key: 'bikini-2', url: 'https://cdn.easysize.me/icons/bikini-swimwear-2.svg' },
	{ key: 'swimsuit-1', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear.svg' },
	{ key: 'swimsuit-2', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear-2.svg' },
	{ key: 'swimsuit-3', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear-3.svg' },
	{ key: 'swimsuit-4', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear-4.svg' },
	{ key: 'swimsuit-5', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear-5.svg' },
	{ key: 'swimsuit-6', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear-6.svg' },
	{ key: 'swimsuit-7', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear-7.svg' },
	{ key: 'swimsuit-7', url: 'https://cdn.easysize.me/icons/swimsuit-swimwear-8.svg' },
]